'use client'

import { useEffect } from 'react'

const INTRO_JS_SRC = 'https://unpkg.com/intro.js/minified/intro.min.js'
const SCRIPT_ID = 'bookwriter-introjs-script'

export function IntroJsLoader() {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }

    const dispatchReady = () => {
      window.dispatchEvent(new Event('introjs-ready'))
    }

    if (window.introJs) {
      dispatchReady()
      return
    }

    const existingScript = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null
    if (existingScript) {
      if (existingScript.dataset.loaded === 'true') {
        dispatchReady()
      } else {
        const handleExistingLoad = () => {
          existingScript.dataset.loaded = 'true'
          dispatchReady()
        }
        existingScript.addEventListener('load', handleExistingLoad, { once: true })
        return () => {
          existingScript.removeEventListener('load', handleExistingLoad)
        }
      }
      return
    }

    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.src = INTRO_JS_SRC
    script.async = true
    script.dataset.loaded = 'false'

    const handleLoad = () => {
      script.dataset.loaded = 'true'
      dispatchReady()
    }

    script.addEventListener('load', handleLoad, { once: true })
    document.body.appendChild(script)

    return () => {
      script.removeEventListener('load', handleLoad)
    }
  }, [])

  return null
}
